(function () {

  function applyDDACustomize() {

    /*
    ----------------------------------------
    改行
    ----------------------------------------
    */
    var paragraphs =
      document.querySelectorAll('.dda-orders p');

    for (var i = 0; i < paragraphs.length; i++) {

      paragraphs[i].style.whiteSpace =
        'pre-line';

    }

    /*
    ----------------------------------------
    limiter翻訳
    ----------------------------------------
    */
    var limiters =
      document.querySelectorAll(
        '.dda-order__asset-limiter'
      );

    for (var i = 0; i < limiters.length; i++) {

      var el = limiters[i];

      var original = el.textContent;

      if (
        original.indexOf('残り') !== -1 ||
        original.indexOf('期限切れ') !== -1
      ) {
        continue;
      }

      var text = original;

      text = text

        .replace(
          /less than an hour/g,
          '残り1時間未満 / less than an hour'
        )

        .replace(
          /a day left/g,
          '残り1日 / a day left'
        )

        .replace(
          /(\d+)\s+days left/g,
          '残り$1日 / $1 days left'
        )

        .replace(
          /(\d+)\s+hours left/g,
          '残り$1時間 / $1 hours left'
        )

        .replace(
          /expired/g,
          '期限切れ / expired'
        );

      if (text !== original) {
        el.textContent = text;
      }

    }

  }

  /*
  ----------------------------------------
  初回
  ----------------------------------------
  */
  applyDDACustomize();

  /*
  ----------------------------------------
  iOS App再描画対策
  ----------------------------------------
  */
  var retry = 0;

  var timer = setInterval(function () {

    applyDDACustomize();

    retry++;

    if (retry > 30) {
      clearInterval(timer);
    }

  }, 500);

})();

/* =========================================================
DDA Download Refresh Fix
========================================================= */

(function () {

  var shouldReloadOnReturn = false;

  /*----------------------------------------
  DL Link Click
  ----------------------------------------*/
  document.addEventListener('click', function (e) {

    var link = e.target.closest(
      '.dda-order__asset-link a'
    );

    if (!link) return;

    if (
      !link.href ||
      !link.href.includes('/apps/digital-downloads/download/')
    ) {
      return;
    }

    console.log(
      '[Digital Download] Click'
    );

    shouldReloadOnReturn = true;

  });

  /*----------------------------------------
  Return Detect
  ----------------------------------------*/
  document.addEventListener(
    'visibilitychange',
    function () {

      if (
        document.visibilityState === 'visible' &&
        shouldReloadOnReturn
      ) {

        /*----------------------------------------
        reload loop guard
        ----------------------------------------*/
        if (window.__ddaReloaded) {
          return;
        }

        window.__ddaReloaded = true;

        console.log(
          '[Digital Download] Return -> Reload'
        );

        shouldReloadOnReturn = false;

        setTimeout(function () {

          window.location.reload();

        }, 500);

      }

    }

  );

})();